import React, { useContext, useEffect, useRef, useState } from "react";
import { DialogTrigger } from "../../../../components/Dialog/Dialog";
import { Expandable } from "../../../../components/Expandable/Expandable";
import Item from "../../../../components/Lists/Item";
import { usePermissions } from "../../../../hooks/usePermissions";
import { TypeSeriesConfigurationContext } from "../../contexts/TypeSeriesConfigurationContext";
import DeleteTypeSeriesDialog from "./DeleteTypeSeriesDialog";
import AircraftConfigurationGrid from "./AircraftConfigurationGrid";
import { DropdownsContext } from "../../../../contexts/DropdownsContext";
import { LABELS } from "../../../../globals/globals";
import AircraftList from "./AircraftList";
import { AircraftConfigurationProvider } from "../../contexts/AircraftConfigurationContext";
import { Tooltip } from "@mui/material";
import { use } from "react";
import { ResultsNotFound } from "../../../../components/ResultsNotFound/ResultsNotFound";
import { AircraftDeliveryInfoProvider } from "../../contexts/AircraftDeliveryInfoContext";
import { AircraftWarrantyProvider } from "../../contexts/AircraftWarrantyContext";
import { AircraftBalanceProvider } from "../../contexts/AircraftBalanceContext";
import { Sorting } from "../../../../components/Lists/Sorting";
import Skeleton from "react-loading-skeleton";
import { calculateActualAircaftsByType } from "../../services/AircraftConfigurationService";
import { DialogContext } from "../../../../contexts/DialogContext";
import { SortingHeader } from "../../../../components/Sorting/SortingHeader";

const localStoragePrefix = "configuration/typeSeries/draft";

const mapper = {
  type: "Type",
  series: "Series",
  totalAircraft: "Total Number of Aircraft",
};
const TypeSeriesList = () => {
  const {
    idxList,
    isAircraftDraft,
    deleteAircraft,
    typeSeriesList,
    requestNextPage,
    loadingAircraft,
    addAircraft,
    newAircraft,
    setNewAircraft,
    setUpdateInfo,
    setTypeSeriesList,
    setSortingOrder,
    setIdxList,
  } = useContext(TypeSeriesConfigurationContext);

  const dropdownIds = [
    30, 31, 7, 44, 45, 46, 47, 33, 34, 35, 36, 37, 38, 39, 41, 42, 43, 61,
  ];
  const listRef = useRef(null);
  const doNothing = () => {};
  const { hasPermission } = usePermissions();
  const { setDropdownIds } = useContext(DropdownsContext);
  const didMount = useRef(false);
  const [openStates, setOpenStates] = useState({});
  const [childrenOpenState, setChildrenOpenState] = useState({});
  const { openDialog, closeDialog } = useContext(DialogContext);
  useEffect(() => {
    setDropdownIds(dropdownIds);
  }, []);
  useEffect(() => {
    if (
      localStorage.getItem(localStoragePrefix + "/new-auto-open") === "true"
    ) {
      listRef.current?.querySelector("summary")?.click();
      localStorage.removeItem(localStoragePrefix + "/new-auto-open");
    }
  }, [typeSeriesList]);
  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - (scrollTop + 3) <= clientHeight) {
      if (!loadingAircraft) requestNextPage();
    }
  };

  useEffect(() => {
    if (newAircraft && newAircraft?.typeSeries) {
      if (childrenOpenState[newAircraft?.typeSeries.id]) {
        return;
      }
      setChildrenOpenState((prevState) => {
        const newState = Object.keys(prevState).reduce((acc, key) => {
          acc[key] = false;
          return acc;
        }, {});

        return {
          ...newState,
          [newAircraft?.typeSeries.id]: true,
        };
      });
      closeAllOpenStates();
    }
  }, [newAircraft]);

  const toggleOpenState = (aircraftId, open) => {
    closeAllOpenStates();
    setTimeout(() => {
      setOpenStates((prevState) => ({
        ...prevState,
        [aircraftId]: open,
      }));
      if (open) {
        setChildrenOpenState((prevState) => {
          const newState = {};
          Object.keys(prevState).forEach((key) => {
            newState[key] = false;
          });
          return newState;
        });
      }
    }, 100);
  };

  const setStatus = (aircraftList, typeSeriesId, fromDelete, draft) => {
    calculateActualAircaftsByType(typeSeriesId)
      .then((response) => {
        if (response.data.responseCode === 200) {
          const item = response.data.load[0];
          setIdxList((prevState) => ({
            ...prevState,
            [typeSeriesId]: {
              ...prevState[typeSeriesId],
              totalAircraft: {
                active: item.active,
                inactive: item.inactive,
                hold: item.hold,
              },
              isAircraft: true,
              countChilds: item.active + item.inactive + item.hold,
              date: new Date().toISOString(),
            },
          }));
          if (Object.keys(aircraftList).length === 0 && fromDelete) {
            setChildrenOpenState((prevState) => {
              const newState = Object.keys(prevState).reduce((acc, key) => {
                acc[key] = false;
                return acc;
              }, {});

              return {
                ...newState,
                [typeSeriesId.id]: false,
              };
            });
          }

          setUpdateInfo({ aircraftList, draft });
        }
      })
      .catch((error) => {
        console.error("Error al calcular los aircrafts por tipo:", error);
      });
  };
  const closeAllOpenStates = () => {
    setOpenStates((prevState) => {
      const newState = {};
      Object.keys(prevState).forEach((key) => {
        newState[key] = false;
      });
      return newState;
    });
  };

  const viewChildren = (aircraft) => {
    if (!aircraft?.countChilds || aircraft?.countChilds === 0) {
      return;
    }
    setNewAircraft(null);
    setChildrenOpenState((prevState) => {
      const newState = Object.keys(prevState).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {});

      return {
        ...newState,
        [aircraft?.id]: !prevState[aircraft?.id],
      };
    });

    closeAllOpenStates();
  };
  const onOrderChange = (order) => {
    if (!didMount.current) {
      didMount.current = true; // Evita la primera ejecución
      return;
    }
    setSortingOrder(order);
  };

  const onDeleteType = (aircraftId) => {
    openDialog({
      component: DeleteTypeSeriesDialog,
      props: {
        aircraft: idxList[aircraftId],
        close: closeDialog,
        onDelete: () => deleteAircraft(aircraftId),
      },
    });
  };
  return (
    <>
      <SortingHeader/>
      {/* <Sorting
        onOrderChange={onOrderChange}
        showHeaderOrder={true}
        properties={{
          Type: "Type",
          Series: "Series",
          total_childs: "Total Number of Aircraft",
        }}
      /> */}
      <div className="type-series-list" ref={listRef} onScroll={handleScroll}>
        {loadingAircraft ? (
          Array.from({ length: 7 }).map((_, idx) => (
            <div key={idx} className="item-container-skeleton">
              <Skeleton
                style={{ borderRadius: "10px" }}
                height="1.68rem"
                width="1.8rem"
              />
              <div className="item-skeleton-content">
                <Skeleton height="1rem" width="80%" />
              </div>
              <Skeleton height="1.5rem" width="7rem" />
            </div>
          ))
        ) : typeSeriesList.length === 0 ? (
          <ResultsNotFound />
        ) : (
          typeSeriesList.map(
            (aircraft, idx) =>
              idxList[aircraft?.id] && (
                <React.Fragment key={`${aircraft?.id}-${idx}`}>
                  <Expandable
                    key={`${aircraft?.id}-${idx}`}
                    name={`${aircraft?.id}-type-configuration-${idx}`}
                    summary={
                      <React.Fragment key={`${aircraft?.id}-${idx}`}>
                        <Item
                          orderedProperties={[
                            "type",
                            "series",
                            "totalAircraft",
                          ]}
                          propertiesPlaceholder={{ ata: "00-00-00" }}
                          labelMapper={mapper}
                          valuePlaceholder="--"
                          itemPrefix={() =>
                            childrenOpenState[aircraft?.id] && (
                              <span className="bulletChild"></span>
                            )
                          }
                          hideLabels={true}
                          lightFont={true}
                          ignoreProperties={[
                            "id",
                            "ATAChapter",
                            "ATASection",
                            "ATAParagraph",
                            "partNumber",
                            "description",
                            "categoryName",
                            "subCategoryName",
                          ]}
                          openRow={(e) => {
                            console.log("Open row clicked", e);
                            e.stopPropagation();
                            viewChildren(idxList[aircraft?.id]);
                          }}
                          item={idxList[aircraft?.id]}
                          ribbon={[
                            {
                              label: LABELS.DRAFT,
                              when: isAircraftDraft(aircraft?.id),
                            },
                          ]}
                          itemSuffix={() => (
                            <div className="button-actions-container">
                              <Tooltip
                                className="custom-tooltip"
                                title={"Add Aircraft"}
                                arrow
                              >
                                <div
                                  className={`aircraft-view-button ${
                                    isAircraftDraft(aircraft?.id)
                                      ? "no-children"
                                      : ""
                                  }`}
                                >
                                  <button
                                    onClick={() => addAircraft(aircraft?.id)}
                                  >
                                    <div className="btn-icon-aircraft-create">
                                      <i className="icon-add-aircraft"></i>
                                    </div>
                                  </button>
                                </div>
                              </Tooltip>
                              <Tooltip
                                className="custom-tooltip"
                                title={
                                  idxList[aircraft?.id]?.countChilds &&
                                  idxList[aircraft?.id]?.countChilds > 0
                                    ? "View Aircrafts"
                                    : "You haven't created an aircraft yet"
                                }
                                arrow
                              >
                                <div
                                  className={`aircraft-view-button ${
                                    !idxList[aircraft?.id]?.countChilds ||
                                    idxList[aircraft?.id]?.countChilds === 0
                                      ? "no-children"
                                      : ""
                                  }`}
                                >
                                  <button
                                    onClick={() =>
                                      viewChildren(idxList[aircraft?.id])
                                    }
                                  >
                                    <div className="btn-icon-aircraft-children">
                                      <i className="icon-aircrafts"></i>
                                    </div>
                                  </button>
                                </div>
                              </Tooltip>
                              {hasPermission("delete") && (
                                <Tooltip
                                  className="custom-tooltip"
                                  title={"Delete Type/Series"}
                                  arrow
                                >
                                  <button
                                    className="delete-part-button"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      onDeleteType(aircraft?.id);
                                    }}
                                  >
                                    <i className="icon-delete-new"></i>
                                  </button>{" "}
                                </Tooltip>
                              )}
                            </div>
                          )}
                        />
                      </React.Fragment>
                    }
                    isOpen={openStates[aircraft?.id]}
                    isChildOpen={childrenOpenState[aircraft?.id]}
                    onToggle={(open) => toggleOpenState(aircraft?.id, open)}
                  >
                    <AircraftConfigurationGrid
                      aircraft={aircraft}
                      open={openStates[aircraft?.id]}
                      setOpen={closeAllOpenStates}
                    ></AircraftConfigurationGrid>
                  </Expandable>

                  {childrenOpenState[aircraft?.id] && (
                    <AircraftConfigurationProvider
                      aircraftId={aircraft?.id}
                      newAircraft={newAircraft}
                    >
                      <AircraftDeliveryInfoProvider>
                        <AircraftWarrantyProvider>
                          <AircraftBalanceProvider>
                            <AircraftList
                              updateInfo={setStatus}
                              typeSeriesId={aircraft?.id}
                              numberOfEngines={aircraft?.number_of_engines}
                              numberOfLandingGears={aircraft?.number_of_landing_gears}
                            ></AircraftList>
                          </AircraftBalanceProvider>
                        </AircraftWarrantyProvider>
                      </AircraftDeliveryInfoProvider>
                    </AircraftConfigurationProvider>
                  )}
                </React.Fragment>
              )
          )
        )}
      </div>
    </>
  );
};

export default TypeSeriesList;
